import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Seo from "@/components/Seo";

export default function PaymentCancel() {
  return (
    <div className="max-w-md mx-auto px-4 py-24 text-center" data-testid="payment-cancel-page">
      <Seo title="Payment cancelled | Appleman Tech Repair" description="Deposit payment cancelled — your booking still stands." />
      <XCircle className="h-16 w-16 mx-auto mb-6 text-neutral-400" />
      <h1 className="font-display font-black uppercase tracking-tight text-4xl mb-4">Payment cancelled</h1>
      <p className="text-neutral-600 mb-8">
        No charge was made. Your booking still stands — you can pay the £10 deposit any time from your account, or pay in full when we see the device.
      </p>
      <Link to="/dashboard" data-testid="cancel-dashboard-link"
        className="inline-block border-2 border-black bg-black text-white px-8 py-4 font-display font-bold uppercase tracking-wider shadow-hard brutal-hover">
        Back to my account
      </Link>
    </div>
  );
}
